import { motion } from "framer-motion";
import React from "react";
import { IoCloseSharp } from "react-icons/io5";
const VideoModal = ({ videoModal, setVideoModal, url }) => {
  const backdropVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
    exit: {
      opacity: 0,
    },
  };
  const modalVariants = {
    hidden: {
      y: "-100vh",
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        delay: 0.3,
        stiffness: 80,
      },
    },
    exit: {
      y: "-100vh",
      opacity: 0,
      transition: {
        duraion: 1,
        type: "anticipate",
      },
    },
  };
  return (
    <motion.div
      className="flex justify-center items-center w-screen fixed top-0 bg-black/70 min-w-screen min-h-screen p-4 z-50 "
      initial="hidden"
      animate="visible"
      variants={backdropVariants}
      exit="exit"
    >
      <IoCloseSharp
        className="absolute top-[25.5%] sm:top-[5%]  right-[calc(7%+0.3rem)] sm:right-[calc(6%+0.2rem)] text-2xl sm:text-3xl font-bold cursor-pointer hover:text-dark text-light z-10"
        onClick={() => setVideoModal({ ...videoModal, isOpen: false })}
      />
      <motion.iframe
        variants={modalVariants}
        src={url}
        title="YouTube video player"
        className=" bg-red-100/20 w-[90%] h-[50vh] sm:h-[90vh] rounded"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      ></motion.iframe>
    </motion.div>
  );
};

export default VideoModal;
